<template>
  <section class="teachers-table">
    <DataTable
      :value="dataSource"
      data-key="Id"
      v-model:filters="filters"
      show-gridlines
      paginator :rows="6"
      :rowsPerPageOptions="[6, 12, 24]"
      edit-mode="row"
      v-model:editing-rows="editingRows"
      state-storage="local"
      scroll-height="80vh"
      :loading="false"
      removable-sort
      class="p-datatable-sm"
      v-model:selection="selectedRow"
      @row-edit-save="$emit('row-edit', $event)"
      @row-dblclick="changeNews"
      @row-select="$emit('row-selected', $event)"
    >
      <Column
        field="Header"
        header="ФИО"
        style="width: 9.75rem"
      >
      </Column>
      <Column
        field="PublicationDate"
        header="Должность"
        bodyStyle="text-align:center"
        style="width: 12.688rem"
      >
        <template #body="slotProps">
          {{ formaterDate(slotProps.data.PublicationDate) }}
        </template>
      </Column>
      <Column
        field="DefferedDate"
        header="Образование"
        bodyStyle="text-align:center"
        style="width: 15.688rem"
      >
        <template #body="slotProps">
          {{ formaterDateTime(slotProps.data.DefferedDate) }}
        </template>
      </Column>
      <Column
        header="Повышение квалификации"
        :body-style="{ 'text-align': 'center' }"
        style="width: 44rem;"
      >
      </Column>
      <Column
        field="PublicationDate"
        header="Учебные курсы"
        :body-style="{ 'text-align': 'center' }"
        style="width: 44rem"
      >
        <template #body="slotProps">
          {{ formaterDate(slotProps.data.PublicationDate) }}
        </template>
      </Column>
      <Column
        field="PublicationDate"
        header="Стаж"
        :body-style="{ 'text-align': 'center' }"
        style="width: 17.688rem"
      >
      <template #body="slotProps">
          {{ formaterDate(slotProps.data.PublicationDate) }}
        </template>
      </Column>
      <Column
        field="PublicationDate"
        header="Контакты"
        :body-style="{ 'text-align': 'center' }"
        style="width: 14.313rem"
      >
      <template #body="slotProps">
          {{ formaterDate(slotProps.data.PublicationDate) }}
        </template>
      </Column>
    </DataTable>
  </section>
</template>

<script>
import { ref, toRef } from 'vue'
import { useStore } from 'vuex'

import { formaterDate, formaterDateTime } from '@/helpers/helpFunctions.js'
import { policiesValid } from '@/helpers/policiesValidator'

import DataTable from 'primevue/datatable'
import Column from 'primevue/column'

export default {
  name: 'TeachersTable',
  components: {
    DataTable,
    Column
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    policies: {
      type: Array,
      default: () => []
    }
  },
  setup (props, { emit }) {
    const store = useStore()

    // const policies = computed(() => store.getters.getPolicies)

    // нужно для работы таблицы по документации
    const filters = ref({
      Vendor: { value: null },
      Header: { value: null },
      PublicationDate: { value: null },
      DefferedDate: { value: null },
      UniversalTagId: { value: null },
      ReadyToPublish: { value: null },
      Published: { value: null }
    })

    const editingRows = ref([])

    const selectedRow = ref()
    // нужно для работы таблицы по документации

    const dataSource = toRef(props, 'data')

    const changeNews = (e) => {
      if (!policiesValid(props.policies, e.data.UniversalTagId, 'editing')) {
        store.dispatch('setShowErrorModal', { Message: 'У Вас нет прав на редактирование' })

        return
      }
      // в том случае если пользователь может редактировать товар/новость
      // то эмитится событие ниже, которе слушается из родительского компонента
      emit('redirectToEditor', e.data.Id)
    }

    return {
      filters,
      policiesValid,
      editingRows,
      dataSource,
      formaterDate,
      changeNews,
      selectedRow,
      formaterDateTime
    }
  }
}
</script>

<style lang="scss" scoped>
.teachers-table {
  overflow-x: auto;

  &::-webkit-scrollbar {
    height: 10px;
    background-color: rgba(192, 192, 192, 0.5);
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgb(27, 166, 218, 0.7);
    border-radius: 5px;

    &:hover {
      background-color: rgb(27, 166, 218);
    }
  }

  &::-webkit-scrollbar-track {
  background-color: #FFFFFF;
  border: 1px solid #ccc;
  border-radius: 5px;
}

  &__header {
    display: flex;
    justify-content: space-between;
    background: #FFFFFF;
    margin-bottom: 16px;

    :deep(.p-inputtext) {
      width: 300px !important;
      height: 40px !important;
      padding: 8px 16px !important;
      color: #848484;
    }
  }

  :deep(.p-datatable-wrapper) {
    width: 100vw;
  }

  &__title {
    font-size: 24px;
    color: #000000;
  }

  :deep(.p-datatable.p-datatable-gridlines .p-datatable-thead > tr > th) {
    background-color: #FFFFFF;
    border-top: none;
    border-left: none;
    border-right: none;
    padding: 4px;
  }

  :deep(.p-column-title) {
    color: #A8A8A8;
    font-weight: 400;
  }

  :deep(.p-paginator .p-paginator-pages .p-paginator-page) {
    border-radius: 18px;
  }

  :deep(.p-paginator .p-paginator-pages .p-paginator-page.p-highlight) {
    background: #1BA6DA;
    color: #FFFFFF;
    border-radius: 18px;
  }

  :deep(.p-inputtext) {
    width: 100%;
    height: 100%;
  }
}
</style>
